import {
  Form,
  Input,
  Select,
  InputNumber,
  DatePicker,
  Switch,
  Upload,
  Button,
} from "antd";
import { previewFile } from "@DELIVERIES";

import { UploadOutlined } from "@ant-design/icons";

const getCustomField = ({ item, fieldName, form }) => {
  const rules = [];
  if (item.required) {
    rules.push({
      required: true,
      message: `Lütfen ${item.label.toLowerCase()} giriniz`,
    });
  }

  const formItemProps = {
    label: item.label,
    name: fieldName !== undefined ? [fieldName, item.name] : item.name,
    rules: rules,
  };

  switch (item.type) {
    case "TEXT":
      return (
        <Form.Item {...formItemProps} initialValue={null}>
          <Input placeholder={item.placeholder || ""} />
        </Form.Item>
      );

    case "NUMBER":
      return (
        <Form.Item {...formItemProps} initialValue={null}>
          <InputNumber
            placeholder={item.placeholder || ""}
            style={{ width: "100%" }}
          />
        </Form.Item>
      );

    case "DATE":
      return (
        <Form.Item {...formItemProps} initialValue={null}>
          <DatePicker
            placeholder={item.placeholder || "Tarih Seçiniz"}
            style={{ width: "100%" }}
            format="DD.MM.YYYY"
          />
        </Form.Item>
      );

    case "TIMESTAMP":
      return (
        <Form.Item {...formItemProps} initialValue={null}>
          <DatePicker
            showTime
            placeholder={item.placeholder || "Tarih ve Saat Seçiniz"}
            style={{ width: "100%" }}
            format="DD.MM.YYYY HH:mm"
          />
        </Form.Item>
      );

    case "BOOLEAN":
      return (
        <Form.Item
          {...formItemProps}
          valuePropName="checked"
          initialValue={null}
        >
          <Switch checkedChildren="Evet" unCheckedChildren="Hayır" />
        </Form.Item>
      );

    case "SELECT_OPTION":
      return (
        <Form.Item {...formItemProps} initialValue={null}>
          <Select
            placeholder={item.placeholder || "Seçim Yapınız"}
            style={{ width: "100%" }}
            options={item.options?.map((opt) => ({
              label: opt.label,
              value: opt.value,
            }))}
            allowClear
          />
        </Form.Item>
      );

    case "FILE_UPLOADER":
      return (
        <Form.Item
          {...formItemProps}
          initialValue={null}
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            const fileList = e?.fileList;

            if (!fileList?.length) {
              return [];
            }

            return [...fileList];
          }}
        >
          <Upload
            name={item.name}
            multiple={false}
            maxCount={1}
            accept="application/pdf"
            beforeUpload={() => false}
            showUploadList
            onPreview={async (file) => {
              if (file.apiUrl) {
                const response = await previewFile(file.apiUrl);
                const blob = new Blob([response.data], {
                  type: "application/pdf",
                });
                const blobUrl = window.URL.createObjectURL(blob);
                window.open(blobUrl);
              }
            }}
          >
            <Button icon={<UploadOutlined />}>{item.placeholder}</Button>
          </Upload>
        </Form.Item>
      );

    default:
      return null;
  }
};

export default getCustomField;
